import React, { useEffect, useState } from "react";
import { Container, Card, CardBody, Button } from "reactstrap";

const SubscriptionExpiry = ({ children }) => {
  const [isExpired, setIsExpired] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [orgInfo, setOrgInfo] = useState(null);

  useEffect(() => {
    const checkSubscriptionStatus = () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));
        if (!userData?.expiryDate) return;

        const expiry = new Date(userData.expiryDate);
        const today = new Date();
        const diffDays = Math.ceil((expiry - today) / (1000 * 3600 * 24));

        setExpiryDate(
          expiry.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        );
        setDaysRemaining(diffDays);
        setOrgInfo(userData.organizationInfo);
        setIsExpired(diffDays < 0);
      } catch (error) {
        console.error("Error checking subscription status:", error);
      }
    };

    checkSubscriptionStatus();
  }, []);

  const handleExtend = () =>
    alert("Redirecting to subscription extension page...");
  const handleSupport = () =>
    (window.location.href = `tel:${orgInfo?.tel || "9851099003"}`);

  // Warning for subscriptions expiring soon
  // if (!isExpired && daysRemaining <= 7 && daysRemaining >= 0) {
  //   return (
  //     <>
  //       <div
  //         className="position-fixed top-0 start-0 w-100 bg-warning text-dark text-center py-2"
  //         style={{ zIndex: 1050 }}
  //       >
  //         Subscription expiring in {daysRemaining}{" "}
  //         {daysRemaining === 1 ? "day" : "days"}.
  //         <Button
  //           color="dark"
  //           size="sm"
  //           className="ms-2"
  //           onClick={handleExtend}
  //         >
  //           Extend
  //         </Button>
  //       </div>
  //       <div style={{ paddingTop: "48px" }}>{children}</div>
  //     </>
  //   );
  // }

  // Expired subscription overlay
  if (isExpired) {
    return (
      <div
        className="position-relative"
        style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
      >
        <div
          style={{ filter: "blur(4px)", opacity: 0.3, pointerEvents: "none" }}
        >
          {children}
        </div>
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9999 }}
        >
          <Container style={{ maxWidth: "400px" }}>
            <Card>
              <CardBody className="text-center">
                <h3 className="text-danger mb-3">Subscription Expired</h3>
                {orgInfo && (
                  <div>
                    <p className="mb-2">{orgInfo.name}</p>
                    <p className="mb-2">{orgInfo.address1}</p>
                  </div>
                )}
                <p className="mb-2">Expired on: {expiryDate}</p>
                <div className="d-grid gap-2 mt-3">
                  <Button color="primary" onClick={handleExtend}>
                    Extend Subscription
                  </Button>
                  <Button color="secondary" outline onClick={handleSupport}>
                    Contact Support
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Container>
        </div>
      </div>
    );
  }

  return children;
};

export default SubscriptionExpiry;
